// import * as React from "react"; // org-switcher (React.useRef used in VirtualOrgList)
import { useNavigate } from "@tanstack/react-router";
// import { useQueryClient } from "@tanstack/react-query"; // org-switcher
// import { useVirtualizer } from "@tanstack/react-virtual"; // org-switcher
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  // DropdownMenuSub,          // org-switcher
  // DropdownMenuSubTrigger,   // org-switcher
  // DropdownMenuSubContent,   // org-switcher
} from "@/components/ui/dropdown-menu";
import {
  LogOut,
  User,
  ChevronDown,
  Shield,
  Languages,
  Palette,
  // Building2, // org-switcher
  // Check,     // org-switcher
  // X,         // org-switcher
} from "lucide-react";
import { t } from "@lingui/core/macro";
// import { useLingui } from "@lingui/react/macro"; // org-switcher
import { Trans } from "@lingui/react/macro";
// import { i18n } from "@lingui/core"; // org-switcher
// import { toast } from "sonner"; // org-switcher
import { useAuth } from "@/hooks/useAuth";
// import { useActiveOrganization } from "@/contexts/ActiveOrganizationContext"; // org-switcher
// import { useActiveLocation } from "@/contexts/ActiveLocationContext"; // org-switcher
// import { switchOrganization } from "@/lib/auth"; // org-switcher
// import type { Organization } from "@/types/organization"; // org-switcher
import { LanguageSwitcher } from "./LanguageSwitcher";
import { ThemeToggle } from "./ThemeToggle";

// ---------------------------------------------------------------------------
// Shared profile / account menu. The dropdown body (`UserMenuItems`) is mounted
// from several triggers: the TopBar (top-right on desktop), the sidebar rail
// (on tablet, via SidebarUserMenu), and the self-contained `UserMenu` avatar
// button (app shell + onboarding). Identity data comes from `useUserMenuData`,
// which is provider-safe; the org switcher mounts its own contexts so the menu
// also works on routes outside the app-shell providers (e.g. onboarding).
// ---------------------------------------------------------------------------

// TODO: org-switcher — commented out, restore when needed.
// function VirtualOrgList({
//   organizations,
//   activeOrganization,
//   onSelect,
// }: {
//   organizations: Organization[];
//   activeOrganization: Organization | null;
//   onSelect: (org: Organization) => void;
// }) {
//   const containerRef = React.useRef<HTMLDivElement>(null);
//   const virtualizer = useVirtualizer({
//     count: organizations.length,
//     getScrollElement: () => containerRef.current,
//     estimateSize: () => 32,
//     overscan: 8,
//   });
//
//   return (
//     <div ref={containerRef} className="h-64 overflow-y-auto">
//       <div style={{ height: virtualizer.getTotalSize(), position: "relative" }}>
//         {virtualizer.getVirtualItems().map((item) => {
//           const org = organizations[item.index];
//           if (!org) return null;
//           return (
//             <DropdownMenuItem
//               key={org.id}
//               onClick={() => onSelect(org)}
//               className="absolute inset-x-0 flex items-center gap-2"
//               style={{ top: item.start, height: item.size }}
//             >
//               <span className="size-3.5 shrink-0 flex items-center justify-center">
//                 {activeOrganization?.id === org.id && (
//                   <Check className="size-3.5 text-(--color-action)" />
//                 )}
//               </span>
//               {org.name}
//             </DropdownMenuItem>
//           );
//         })}
//       </div>
//     </div>
//   );
// }
//
// /**
//  * Organization switcher submenu. Encapsulates the app-shell contexts it depends
//  * on (active organization / location) so it is only mounted — and those hooks
//  * only run — when the menu is rendered with `showOrgSwitcher`. This keeps the
//  * profile menu usable on routes outside those providers (e.g. onboarding).
//  */
// function OrgSwitcherSubMenu() {
//   const { t } = useLingui();
//   const { refetchUser } = useAuth();
//   const queryClient = useQueryClient();
//   const { activeOrganization, setActiveOrganization, organizations } =
//     useActiveOrganization();
//   const { setActiveLocation } = useActiveLocation();
//
//   async function handleOrgSelect(org: Organization) {
//     try {
//       await switchOrganization(org.id);
//       setActiveOrganization(org);
//       setActiveLocation(null);
//       void refetchUser();
//       void queryClient.invalidateQueries({
//         predicate: (q) => q.queryKey[0] !== "auth",
//       });
//     } catch {
//       toast.error(t`Failed to switch organization`);
//     }
//   }
//
//   async function handleClearOrg() {
//     try {
//       // Clear the backend org context too, not just the local selection — that
//       // is what puts the super admin into all-organizations mode server-side.
//       await switchOrganization(null);
//       setActiveOrganization(null);
//       setActiveLocation(null);
//       void refetchUser();
//       void queryClient.invalidateQueries({
//         predicate: (q) => q.queryKey[0] !== "auth",
//       });
//     } catch {
//       toast.error(i18n._("Failed to clear organization"));
//     }
//   }
//
//   return (
//     <>
//       <DropdownMenuSub>
//         <DropdownMenuSubTrigger className="flex items-center gap-2 px-2 py-1.5 text-sm">
//           <Building2 className="h-4 w-4 text-(--color-text-secondary) shrink-0" />
//           <span className="flex-1 truncate">
//             {activeOrganization?.name ?? t`Select organization`}
//           </span>
//         </DropdownMenuSubTrigger>
//         <DropdownMenuSubContent className="min-w-52">
//           <DropdownMenuLabel className="text-xs text-(--color-text-secondary) font-normal">
//             {i18n._("Switch organization")}
//           </DropdownMenuLabel>
//           <DropdownMenuSeparator />
//           <VirtualOrgList
//             organizations={organizations}
//             activeOrganization={activeOrganization}
//             onSelect={handleOrgSelect}
//           />
//           {activeOrganization && (
//             <>
//               <DropdownMenuSeparator />
//               <DropdownMenuItem
//                 onClick={() => void handleClearOrg()}
//                 className="flex items-center gap-2 text-(--color-text-secondary)"
//               >
//                 <X className="size-3.5 shrink-0" />
//                 {i18n._("Clear organization")}
//               </DropdownMenuItem>
//             </>
//           )}
//         </DropdownMenuSubContent>
//       </DropdownMenuSub>
//       <DropdownMenuSeparator />
//     </>
//   );
// }

/**
 * Identity + actions for the profile menu, shared by every trigger. Deliberately
 * provider-safe: it only depends on auth, so it can run on routes without the
 * app-shell organization/location providers. The org switcher pulls those
 * contexts itself, in `OrgSwitcherSubMenu`.
 */
export function useUserMenuData() {
  const { user, signOut, hasPermission, hasRole } = useAuth();
  const navigate = useNavigate();

  const isSuperAdmin = hasPermission("*:*") || hasRole("SUPER_ADMIN");

  const firstName = user?.firstName || "";
  const lastName = user?.lastName || "";
  const effectiveDisplayName =
    `${firstName} ${lastName}`.trim() || user?.email || t`User`;
  const effectiveUserRole =
    user?.roles?.[0]?.name || user?.roles?.[0]?.code || null;

  const actorFirstName = user?.impersonationActor?.firstName || "";
  const actorLastName = user?.impersonationActor?.lastName || "";
  const actorDisplayName =
    `${actorFirstName} ${actorLastName}`.trim() ||
    user?.impersonationActor?.email ||
    effectiveDisplayName;

  const isImpersonating =
    !!user?.isImpersonating && !!user?.impersonationActor;
  const displayName = isImpersonating ? actorDisplayName : effectiveDisplayName;
  const displayEmail = isImpersonating
    ? user?.impersonationActor?.email
    : user?.email;
  const displayRole = isImpersonating
    ? user?.impersonationActor?.roleName || effectiveUserRole
    : effectiveUserRole;

  const initials =
    displayName
      .split(" ")
      .filter(Boolean)
      .map((n: string) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2) || t`User`.slice(0, 2);

  return {
    displayName,
    displayEmail,
    displayRole,
    initials,
    isSuperAdmin,
    onProfile: () => navigate({ to: "/profile" }),
    onSignOut: () => signOut(),
  };
}

interface UserMenuSections {
  /** Show the super-admin organization switcher. Requires the app-shell providers. */
  showOrgSwitcher?: boolean;
  /** Show the language / theme preference controls. */
  showPreferences?: boolean;
  /** Show the link to the profile page. */
  showProfile?: boolean;
}

/**
 * The dropdown body for the profile menu, shared across mount points (TopBar,
 * sidebar rail, and the self-contained `UserMenu`). Mount it inside a
 * `<DropdownMenu>` whose trigger the caller supplies. Sections can be toggled
 * off for contexts that don't apply yet (e.g. onboarding).
 */
export function UserMenuItems({
  side,
  align = "end",
  // showOrgSwitcher = true, // org-switcher
  showPreferences = true,
  showProfile = true,
}: UserMenuSections & {
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
}) {
  const { displayName, displayEmail, displayRole, onProfile, onSignOut } =
    useUserMenuData();

  return (
    <DropdownMenuContent side={side} align={align} className="w-56">
      <div className="px-2 py-2">
        <p className="text-sm font-medium">{displayName}</p>
        {displayEmail && (
          <p className="text-xs text-(--color-text-secondary)">{displayEmail}</p>
        )}
      </div>
      <DropdownMenuSeparator />
      {displayRole && (
        <>
          <div className="flex items-center gap-2 px-2 py-1.5">
            <Shield className="h-4 w-4 text-(--color-text-secondary)" />
            <span className="text-sm text-(--color-text-secondary)">{displayRole}</span>
          </div>
          <DropdownMenuSeparator />
        </>
      )}
      {/* org-switcher: {showOrgSwitcher && isSuperAdmin && <OrgSwitcherSubMenu />} */}
      {showPreferences && (
        <>
          <DropdownMenuLabel className="text-xs uppercase tracking-wide text-(--color-text-secondary)">
            <Trans>Preferences</Trans>
          </DropdownMenuLabel>
          <div className="space-y-2 px-2 py-1.5">
            <div className="flex items-center gap-2">
              <Languages className="h-4 w-4 text-(--color-text-secondary)" />
              <LanguageSwitcher className="h-9 w-full" />
            </div>
            <div className="flex items-center justify-between gap-2">
              <span className="inline-flex items-center gap-2 text-sm text-(--color-text-secondary)">
                <Palette className="h-4 w-4" />
                <Trans>Theme</Trans>
              </span>
              <ThemeToggle className="h-9 w-9 border border-(--shell-border) bg-(--shell-control-bg) hover:bg-(--color-surface-accent)" />
            </div>
          </div>
          <DropdownMenuSeparator />
        </>
      )}
      {showProfile && (
        <>
          <DropdownMenuItem onClick={onProfile}>
            <User className="mr-2 h-4 w-4" />
            <Trans>Profile</Trans>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
        </>
      )}
      <DropdownMenuItem onClick={onSignOut}>
        <LogOut className="mr-2 h-4 w-4" />
        <Trans>Sign out</Trans>
      </DropdownMenuItem>
    </DropdownMenuContent>
  );
}

/**
 * Avatar button with the user dropdown — a self-contained trigger + body. Used
 * by the onboarding header and as the default app-shell profile menu;
 * onboarding opts out of the sections that don't apply yet.
 */
export function UserMenu({
  showOrgSwitcher = true,
  showPreferences = true,
  showProfile = true,
  align = "end",
}: UserMenuSections & { align?: "start" | "center" | "end" }) {
  const { displayName, displayEmail, initials } = useUserMenuData();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 rounded-lg border border-(--shell-border) bg-(--shell-control-bg) px-2 py-1.5 outline-none transition-colors hover:bg-(--color-surface-accent) focus-visible:ring-2 focus-visible:ring-(--color-ring) md:mr-4">
          <Avatar className="h-7 w-7 border border-(--color-border) md:h-8 md:w-8">
            <AvatarFallback className="text-xs">{initials}</AvatarFallback>
          </Avatar>
          <div className="hidden md:flex flex-col text-left leading-tight">
            <span className="text-sm font-medium text-(--color-text-primary)">
              {displayName}
            </span>
            {displayEmail && (
              <span className="text-[11px] text-(--color-text-secondary)">
                {displayEmail}
              </span>
            )}
          </div>
          <ChevronDown className="hidden md:block size-4 text-(--color-text-secondary)" />
        </button>
      </DropdownMenuTrigger>
      <UserMenuItems
        align={align}
        showOrgSwitcher={showOrgSwitcher}
        showPreferences={showPreferences}
        showProfile={showProfile}
      />
    </DropdownMenu>
  );
}
